module.exports = __webpack_public_path__ + "79923ba14ab95db6060b7e3e531af8d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/kontakt/NeuBig.jpg
// module id = 348
// module chunks = 0